import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { ClusterInvoiceDto } from 'src/api/v2';
import { Link } from 'react-router-dom';
import { ROUTES } from 'src/navigation';

const columnHelper =
  createColumnHelper<
    Omit<ClusterInvoiceDto, 'invoiceId' | 'invoiceDate' | 'description' | 'invoiceNumber'>
  >();

export const useInvoicesByClusterMemberColumns = () => {
  return [
    columnHelper.accessor((row) => row.clusterMemberName, {
      id: 'clusterMemberName',
      cell: ({
        getValue,
        row: {
          original: { clusterMemberId },
        },
      }) => {
        return (
          <Link to={ROUTES.RESOURCE_BASE.MEMBERS.DETAILS(clusterMemberId || '').INVOICES()}>
            {getValue()}
          </Link>
        );
      },
      minSize: 200,
    }),
    columnHelper.accessor('clusterMemberOrgNo', { id: 'clusterMemberOrgNo' }),
    columnHelper.accessor('marketValue', { id: 'marketValue' }),
    columnHelper.accessor('deductible', { id: 'deductible' }),
  ];
};
